/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DoctorPackageDto } from '../model';
// @ts-ignore
import { EditDoctorPackageDto } from '../model';
/**
 * AdminDoctorPackageControllerApi - axios parameter creator
 * @export
 */
export const AdminDoctorPackageControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DoctorPackageDto} doctorPackageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDoctorPackage: async (doctorPackageDto: DoctorPackageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'doctorPackageDto' is not null or undefined
            assertParamExists('addDoctorPackage', 'doctorPackageDto', doctorPackageDto)
            const localVarPath = `/api/admin/doctor-package`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(doctorPackageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDoctorPackage: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDoctorPackage', 'id', id)
            const localVarPath = `/api/admin/doctor-package/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {EditDoctorPackageDto} editDoctorPackageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDoctorPackage: async (id: number, editDoctorPackageDto: EditDoctorPackageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('editDoctorPackage', 'id', id)
            // verify required parameter 'editDoctorPackageDto' is not null or undefined
            assertParamExists('editDoctorPackage', 'editDoctorPackageDto', editDoctorPackageDto)
            const localVarPath = `/api/admin/doctor-package/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editDoctorPackageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} activeOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDoctorPackages: async (activeOnly: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'activeOnly' is not null or undefined
            assertParamExists('getDoctorPackages', 'activeOnly', activeOnly)
            const localVarPath = `/api/admin/doctor-package`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (activeOnly !== undefined) {
                localVarQueryParameter['activeOnly'] = activeOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminDoctorPackageControllerApi - functional programming interface
 * @export
 */
export const AdminDoctorPackageControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminDoctorPackageControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DoctorPackageDto} doctorPackageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDoctorPackage(doctorPackageDto: DoctorPackageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<DoctorPackageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDoctorPackage(doctorPackageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDoctorPackage(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDoctorPackage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {EditDoctorPackageDto} editDoctorPackageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editDoctorPackage(id: number, editDoctorPackageDto: EditDoctorPackageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<DoctorPackageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editDoctorPackage(id, editDoctorPackageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {boolean} activeOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDoctorPackages(activeOnly: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<Array<DoctorPackageDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDoctorPackages(activeOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminDoctorPackageControllerApi - factory interface
 * @export
 */
export const AdminDoctorPackageControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminDoctorPackageControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {DoctorPackageDto} doctorPackageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDoctorPackage(doctorPackageDto: DoctorPackageDto, options?: any): Promise<DoctorPackageDto> {
            return localVarFp.addDoctorPackage(doctorPackageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDoctorPackage(id: number, options?: any): Promise<void> {
            return localVarFp.deleteDoctorPackage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {EditDoctorPackageDto} editDoctorPackageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editDoctorPackage(id: number, editDoctorPackageDto: EditDoctorPackageDto, options?: any): Promise<DoctorPackageDto> {
            return localVarFp.editDoctorPackage(id, editDoctorPackageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} activeOnly 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDoctorPackages(activeOnly: boolean, options?: any): Promise<Array<DoctorPackageDto>> {
            return localVarFp.getDoctorPackages(activeOnly, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminDoctorPackageControllerApi - object-oriented interface
 * @export
 * @class AdminDoctorPackageControllerApi
 * @extends {BaseAPI}
 */
export class AdminDoctorPackageControllerApi extends BaseAPI {
    /**
     * 
     * @param {DoctorPackageDto} doctorPackageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDoctorPackageControllerApi
     */
    public addDoctorPackage(doctorPackageDto: DoctorPackageDto, options?: AxiosRequestConfig) {
        return AdminDoctorPackageControllerApiFp(this.configuration).addDoctorPackage(doctorPackageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDoctorPackageControllerApi
     */
    public deleteDoctorPackage(id: number, options?: AxiosRequestConfig) {
        return AdminDoctorPackageControllerApiFp(this.configuration).deleteDoctorPackage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {EditDoctorPackageDto} editDoctorPackageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDoctorPackageControllerApi
     */
    public editDoctorPackage(id: number, editDoctorPackageDto: EditDoctorPackageDto, options?: AxiosRequestConfig) {
        return AdminDoctorPackageControllerApiFp(this.configuration).editDoctorPackage(id, editDoctorPackageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} activeOnly 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDoctorPackageControllerApi
     */
    public getDoctorPackages(activeOnly: boolean, options?: AxiosRequestConfig) {
        return AdminDoctorPackageControllerApiFp(this.configuration).getDoctorPackages(activeOnly, options).then((request) => request(this.axios, this.basePath));
    }
}
